import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const LINKS = [
  { href: "#subjects", label: "Subjects" },
  { href: "#how-it-works", label: "How it works" },
  { href: "#about", label: "About" },
  { href: "#pricing", label: "Pricing" },
  { href: "#faqs", label: "FAQs" },
  { href: "#contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 z-50 w-full border-b border-white/40 bg-white/85 backdrop-blur-xl" data-testid="navbar">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <a href="#top" className="flex items-center gap-2.5" data-testid="navbar-logo">
          <img src="/bsa-logo.png" alt="BSA Skills Academy logo" className="h-10 w-10 rounded-lg object-contain" />
          <span className="font-heading leading-tight">
            <span className="block text-sm font-extrabold tracking-tight text-primary">BSA Skills Academy</span>
            <span className="block text-[11px] font-semibold uppercase tracking-[0.18em] text-secondary">Tutoring</span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex" data-testid="navbar-links">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-semibold text-foreground/70 transition-colors duration-200 hover:text-primary"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <Button asChild className="rounded-full bg-primary px-5 font-heading font-bold hover:bg-[#082A45]" data-testid="nav-book-lesson-btn">
            <a href="#book">Book a lesson</a>
          </Button>
        </div>

        <button
          className="rounded-lg p-2 text-primary lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-border bg-white px-4 py-4 lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-semibold text-foreground/80 hover:bg-muted"
              >
                {l.label}
              </a>
            ))}
            <Button asChild className="mt-2 rounded-full bg-primary font-heading font-bold" data-testid="nav-mobile-book-btn">
              <a href="#book" onClick={() => setOpen(false)}>Book a lesson</a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};
